Ext.define('WindowLoadPhoto', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.wgraj_zdjecie.capitalise(),
    width: 350,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    layout: 'fit',
    scrollable: true,
    photoasbase64: null,
    initComponent: function (config) {
        this.cid = Ext.id();
        this.items = [{
            id: this.cid + "formpanel",
            xtype: 'form',
            frame: true,
            border: false,
            autoWidth: true,
            autoHeight: true,
            labelWidth: 80,
            bodyStyle: 'padding:10px 10px 10px 10px',
            defaults: {
                anchor: "0",
                labelWidth: 80
            },
            fileUpload: true,
            items: [{
                xtype: 'filefieldexd',
                id: this.cid + 'file',
                name: 'file',
                fieldLabel: Lang.zdjecie,
                allowBlank: false,
                blankText: Lang.pole_nie_moze_byc_puste,
                accept: 'image/*;capture=camera',
                ensureExtensions: ["." + "jpeg", "." + "jpg", "." + "png", "." + "heic" + "." + "heif", "." + "raw"],
                ensureExtensionsValidErrorMsg: Lang.wymagane_rozszerzenie + " " + ["." + "jpeg", "." + "jpg", "." + "png", "." + "heic" + "." + "heif", "." + "raw"].toString() + "!",
                validator: Ext.ux.form.FileUploadField.prototype.defaultValidatorExtension,
                listeners: {
                    change: function (fld, value) {
                        var form = fld.up('form').getForm();
                        if (form.isValid()) {
                            var file = fld.fileInputEl.dom.files[0];
                            if (file) {
                                this.saveOp();
                            }
                        }
                    }.bind(this)
                },
                fieldStyle: 'height: 37px; font-size: 16px; line-height: 38px;',
                buttonConfig: {
                    cls: 'custom-file-upload-button'
                }
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.close
        }];
        this.callParent(arguments);
    },
    showW: function () {
        this.show();
        this.center();
        this.setKeyMap({
            'ESC': {
                scope: this,
                handler: this.close
            }
        });
    },
    saveOp: function () {
        var self = this;
        var canWrite = false;
        if (Ext.getCmp(this.cid + "formpanel").form.isValid()) {
            canWrite = true;
        }
        if (canWrite) {
            var fileField = Ext.getCmp(this.cid + 'file');
            var file = fileField.fileInputEl.dom.files[0];
            if (file) {
                var fileName = file.name.toLowerCase();
                if (fileName.endsWith(".heic") || fileName.endsWith(".heif")) {
                    this.convertHeicToJpegOrPng(file, function (convertedFile) {
                        self.fileToBase64(convertedFile, function (base64) {
                            self.photoasbase64 = base64;
                            self.closeOp();
                        });
                    });
                } else {
                    this.fileToBase64(file, function (base64) {
                        self.photoasbase64 = base64;
                        self.closeOp();
                    });
                }
            } else {
                Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            }
        } else {
            Ext.getCmp(this.cid + 'save').setDisabled(false);
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
        }
    },
    fileToBase64: function (file, callback) {
        var reader = new FileReader();
        reader.onload = function () {
            var base64 = reader.result;
            callback(base64);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
        reader.readAsDataURL(file);
    },
    convertHeicToJpegOrPng: function (file, callback) {
        var myMask = new Ext.LoadMask({
            target: this
        });
        myMask.show();
        heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.7,
            offscreenCanvas: true
        })
        .then(function (blob) {
            var newFile = new File([blob], file.name.replace(/\.heic|\.heif/i, ".jpg"), {
                type: "image/jpeg",
                lastModified: Date.now()
            });
            callback(newFile);
        })
        .catch(function (error) {
            myMask.hide();
            console.error("Error during HEIC conversion: ", error);
            Ext.MessageBox.alert(Lang.error, "Conversion error: " + error);
        });
    },
    closeOp: function () {
        this.fireEvent("wclose", this.photoasbase64);
        this.close();
    }
});
